export const types = [
    { code: 'TIME', name: 'Цаг үеийн мэдээ', nameEng: 'Time news' },
];
